import React from 'react';
import Typo from '../typo';

const MatchCardDate = ({ matchdate }) => {
  return (
    <>
      <div className='si-matchCard__date'>
        <Typo component={'p'} transKey={'match_card__date'}>
          {matchdate}
        </Typo>
      </div>
    </>
  );
};

export default MatchCardDate;
